import { FILTER_VALUES } from './constants';

const FILTER = {
  FILTER_STORAGE_KEY: 'sessionMeetings_filters',

  read() {
    return JSON.parse(localStorage.getItem(this.FILTER_STORAGE_KEY)) || {};
  },

  write(payload) {
    const data = this.read();
    localStorage.setItem(
      this.FILTER_STORAGE_KEY,
      JSON.stringify({
        ...data,
        ...payload,
      }),
    );
  },

  get [FILTER_VALUES.FUTURE]() {
    return this.read()[FILTER_VALUES.FUTURE];
  },
  set [FILTER_VALUES.FUTURE](filter) {
    this.write({ [FILTER_VALUES.FUTURE]: filter });
  },
  get [FILTER_VALUES.PAST]() {
    return this.read()[FILTER_VALUES.PAST];
  },
  set [FILTER_VALUES.PAST](filter) {
    this.write({ [FILTER_VALUES.PAST]: filter });
  },
};

export default FILTER;
